import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface ParameterTree {
  companyName: string
  site?: any
}
export interface ParameterTreeState {
  isLoading: boolean
  loadingError: string | null
  menuInfo: ParameterTree[] | null
  httpStatus: number | null
}
export const initialState: ParameterTreeState = {
  isLoading: true,
  loadingError: null,
  menuInfo: null,
  httpStatus: null
}

const parameterTreeSclice = createSlice({
  name: 'parameterTree',
  initialState,
  reducers: {
    parameterTreeLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        menuInfo: null,
        httpStatus: 0
      }
    },
    parameterTreeUpdateAction: (state, action: PayloadAction<{ data: ParameterTree[], httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        menuInfo: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    parameterTreeErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        menuInfo: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  parameterTreeLoadingAction,
  parameterTreeUpdateAction,
  parameterTreeErrorAction
} = parameterTreeSclice.actions

export default parameterTreeSclice.reducer
